import { style, styleVariants } from "@vanilla-extract/css";
import { recipe, RecipeVariants } from "@vanilla-extract/recipes";
import { breakpoints, textTruncate, vars } from "plos/src/styles";

export const leaguesTableWrapper = style({
  overflow: "auto",
});

export const leaguesTableRow = styleVariants({
  default: [],
  mine: [
    {
      background: vars.colors.blueBrandGradient,
      selectors: {
        '[dir="rtl"] &': {
          background: vars.colors.blueBrandGradientRtl,
        },
      },
    },
  ],
});

export type LeaguesTableRowVariants = keyof typeof leaguesTableRow;

export const leaguesTableCol = style([
  textTruncate,
  {
    padding: `${vars.space.xs} ${vars.space["2xs"]}`,
    textAlign: "start",
    fontFamily: vars.fonts.bold,
    fontWeight: 400,
    "@media": {
      [`screen and (min-width:${breakpoints[0]})`]: {
        padding: `${vars.space.xs} ${vars.space.xs}`,
      },
    },
  },
]);

export const rankCol = style([
  leaguesTableCol,
  {
    width: "15%",
  },
]);

export const numericCol = style([
  leaguesTableCol,
  {
    width: "15%",
    textAlign: "end",
  },
]);

const cellBase = style({
  padding: `${vars.space.s} ${vars.space["2xs"]}`,
  maxWidth: 200,
  "@media": {
    [`screen and (min-width:${breakpoints[0]})`]: {
      padding: `${vars.space.s} ${vars.space.xs}`,
    },
  },
});

export const leaguesTableCell = recipe({
  base: [cellBase],
  variants: {
    mine: {
      true: {
        backgroundColor: vars.colors.glass,
        color: vars.colors.white,
      },
    },
    numeric: {
      true: {
        textAlign: "end",
      },
    },
    borderBottom: {
      true: {
        borderBottom: `1px solid ${vars.colors.outlineVariant}`,
      },
    },
  },
});

export type LeaguesTableCellVariants = RecipeVariants<typeof leaguesTableCell>;

export const pager = style({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
});

export const nextButton = style({
  marginInlineStart: "auto",
});

export const teamCellContainer = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.s,
});
